import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'
import styled from 'styled-components'
import { NAV_MODULE_ICON } from '../../constants'
import { SVGIcon } from '..'
import { getVersionIcon } from '../../helpers/utils'

const Button = styled.button`
  background: none;
  border: none;
  height: var(--share-button-px);
  width: var(--share-button-px);
  padding: 7px 0px 0px 0px;
  margin: 0;
`

const CopyUrl = ({ translated, version }) => {
    const [ tooltip, setTooltip ] = useState(translated.copyUrl)
    const url = window.location.href
    const tooltipComponent = <Tooltip id="cu-tooltip">{tooltip}</Tooltip>
    return (
        <OverlayTrigger
          placement="top"
          overlay={tooltipComponent}
          shouldUpdatePosition={true}
        >
          <CopyToClipboard text={url} onCopy={() => setTooltip(translated.copied)}>
            <Button>
              <SVGIcon
                src={getVersionIcon(NAV_MODULE_ICON.copy, version)}
              />
            </Button>
          </CopyToClipboard>
        </OverlayTrigger>
      )
}

export default CopyUrl



// WEBPACK FOOTER //
// ./src/components/CopyUrl/index.js